import { useState } from "react"
import { Drawer, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { createPortalPair } from "lib/portals"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

const [HistoricalDrawerPortal, HistoricalDrawerContent] = createPortalPair("HistoricalLibraryDrawer")

export { HistoricalDrawerContent }

export function HistoricalLibraryDrawerButton({ historicalMode }) {
    const [open, setOpen] = useState(false)
    const theme = useTheme()

    return (
        <>
            <Tooltip title="Historical Library Browser">
                <IconButton
                    size="small"
                    onClick={() => setOpen(true)}
                    sx={{
                        border: `1px solid ${theme.palette.divider}`,
                        borderRadius: 1,
                        px: 1,
                        color: historicalMode ? "warning.main" : "text.secondary",
                        bgcolor: historicalMode ? "warning.lighter" : "transparent",
                    }}
                >
                    <Iconify icon="eva:clock-outline" width={20} height={20} />
                    <If value={historicalMode}>
                        <Typography variant="caption" sx={{ ml: 0.5, fontWeight: 600 }}>
                            Historical
                        </Typography>
                    </If>
                </IconButton>
            </Tooltip>

            <Drawer
                anchor="right"
                open={open}
                onClose={() => setOpen(false)}
                PaperProps={{
                    sx: { width: 380, p: 3 },
                }}
            >
                <Stack spacing={3}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="h6">Historical Browser</Typography>
                        <IconButton aria-label="Close" size="small" onClick={() => setOpen(false)}>
                            <Iconify icon="eva:close-fill" />
                        </IconButton>
                    </Stack>

                    <HistoricalDrawerPortal />
                </Stack>
            </Drawer>
        </>
    )
}
